module.exports = __webpack_public_path__ + "static/media/espiral.7274c761.svg";